import L from "leaflet"; // Import is necessary to function leaflet


// Function to get the bearing angle between two Points
const getBearing = (point1, point2) => {
    const φ1 = point1[0] * Math.PI / 180;
    const long_diff = (point2[1] - point1[1]) * Math.PI / 180;
    const φ2 = point2[0] * Math.PI / 180;

    const y = Math.sin(long_diff) * Math.cos(φ2);
    const x = Math.cos(φ1) * Math.sin(φ2) - Math.sin(φ1) * Math.cos(φ2) * Math.cos(long_diff);


    const θ = Math.atan2(y, x);

    const bearing = (θ * 180 / Math.PI + 360) % 360;

    console.log(bearing);

    return bearing;

}

// Function to get distance b/w two points in [lat, long]
const getDistance = (pt1, pt2) => {
    const R = 6371e3; // metres
    const φ1 = pt1[0] * Math.PI / 180; // φ, λ in radians
    const φ2 = pt2[0] * Math.PI / 180;
    const Δφ = (pt2[0] - pt1[0]) * Math.PI / 180;
    const Δλ = (pt2[1] - pt1[1]) * Math.PI / 180;

    const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
        Math.cos(φ1) * Math.cos(φ2) *
        Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    const d = R * c; // in metres

    return d;
}

// Function to get the [lat,long] point at a certain distance and angle from the given point
const getLatLong = (lat1, long1, deg, d) => {
    const φ1 = lat1 * Math.PI / 180;
    const λ1 = long1 * Math.PI / 180;
    const brng = (deg * Math.PI) / 180;
    const R = 6378137;
    const θ = d / R;
    const φ2 = Math.asin(Math.sin(φ1) * Math.cos(θ) + Math.cos(φ1) * Math.sin(θ) * Math.cos(brng));
    const λ2 = λ1 + Math.atan2(Math.sin(brng) * Math.sin(θ) * Math.cos(φ1), Math.cos(θ) - Math.sin(φ1) * Math.sin(φ2));

    const point2 = [parseFloat((φ2 * 180 / Math.PI).toFixed(6)), parseFloat((((λ2 * 180 / Math.PI) + 540) % 360 - 180).toFixed(6))];

    return point2;
}

// Get all the lines from the point and bearing angle
const getLines = (teePoint, bearing, distance) => {
    // console.log(teePoint, bearing, "point bearing");
    const linePoints = [];
    const lines = [];
    let φ1 = teePoint[0];
    let λ1 = teePoint[1];
    for (let i = 0; i < 5; i++) {
        if (i != 0) {
            φ1 = linePoints[i - 1][0];
            λ1 = linePoints[i - 1][1];
        }

        let linePoint = getLatLong(φ1, λ1, bearing, distance/5);
        // let linePoint = getLatLong(φ1, λ1, bearing, 70);
        let line = [getLatLong(linePoint[0], linePoint[1], bearing + 90, 100), getLatLong(linePoint[0], linePoint[1], bearing + 270, 100)];

        linePoints.push(linePoint);
        lines.push(line);
    }

    // console.log(lines, "line");

    return lines;
}

// Render the lines to the map
const renderLines = (_geoJsonData, _featureGroupRef, setHoleCoords) => {
    let leafletGeoJSON = new L.GeoJSON(_geoJsonData);
    if (!leafletGeoJSON) return

    leafletGeoJSON.eachLayer((layer) => {
        try {
            try {

                const { label, ...rest } = layer.feature.properties['toolTip'];

                layer.bindTooltip((layer) => label, rest); //merely sets the tooltip text

                const geoJSON = layer.toGeoJSON()
                console.log(geoJSON, "lines geoJson");
                setHoleCoords(({ features, ...rest }) => {
                    return {
                        ...rest,
                        features: [
                            ...features,
                            geoJSON
                        ]

                    }
                })

            } catch (e) {

            }


            _featureGroupRef.current.addLayer(layer);
            // debugger
        }
        catch (e) {

        }
    });
}

export const getAndRenderLines = (holeCoordsRef, layer, _featureGroupRef, setHoleCoords) => {
    const teePoint = holeCoordsRef.current.features.find((feature) => feature.properties['toolTip'].label === "Tee point").geometry.coordinates;
    const finishPoint = layer.toGeoJSON().geometry.coordinates;
    const brng = getBearing(teePoint, finishPoint);
    const distance = getDistance(teePoint, finishPoint);

    const lines = getLines(teePoint, brng, distance);
    // console.log(lines, "lines");

    // Mapping the lines in geoJSON format
    const linesFeatures = lines.map((line, index) => {
        return {
            geometry: {
                coordinates: line,
                type: "LineString"

            },
            properties: {
                id: Math.random(),
                createdAt: new Date().toISOString(),
                toolTip: {
                    label: `${index + 1} quarter line`,
                    offset: [15, -40],
                    permanent: false,
                    opacity: 0
                }
            },
            type: "Feature"
        }
    })

    const linesGeoJSON = {
        features: linesFeatures,
        type: "FeatureCollection"
    }

    // Rendering and setting the lines in hole coordinates
    renderLines(linesGeoJSON, _featureGroupRef, setHoleCoords);
}